import { apiRequest } from '../../Store/reducers/APIReducer';
import { store } from '../../Store/store';

const handleApiResponse = async (request) => {
    const response = await request;
    if (response.error) {
        throw new Error(response.error.message || "API request failed");
    }
    return response.payload;
};

const apiGet = async (url, options = {}) => {
    try {
        const response = await store.dispatch(apiRequest({ method: 'get', url, ...options }));
        return handleApiResponse(response);
    } catch (error) {
        console.error("API GET Error:", error);
        return null;
    }
};

const apiPost = async (url, payload, options = {}) => {
    try {
        const response = await store.dispatch(apiRequest({ method: 'post', url, payload, ...options }));
        return handleApiResponse(response);
    } catch (error) {
        console.error("API POST Error::", error);
        return null;
    }
};

const apiPut = async (url, payload, options = {}) => {
    try {
        const response = await store.dispatch(apiRequest({ method: 'put', url, payload, ...options }));
        return handleApiResponse(response);
    } catch (error) {
        console.error("API PUT Error:", error);
        return null;
    }
};

const apiDelete = async (url, options = {}) => {
    try {
        const response = await store.dispatch(apiRequest({ method: 'delete', url, ...options }));
        return handleApiResponse(response);
    } catch (error) {
        console.error("API DELETE Error:", error);
        return null;
    }
};

export { apiGet, apiPost, apiPut, apiDelete };
